import * as React from 'react';

function SvgBm(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 480"
            width={props.width || 640}
            height={props.height || 480}
            {...props}
        >
            <path fill="#cf142b" d="M0 0h640v480H0z" />
            <path fill="#00247d" d="M0 0h320v160H0z" />
            <path
                d="M0 0v17.888L284.224 160H320v-17.888L35.776 0H0zm320 0v17.888L35.776 160H0v-17.888L284.224 0H320z"
                fill="#fff"
            />
            <path d="M133.333 0v160h53.334V0h-53.334zM0 53.333v53.334h320V53.333H0z" fill="#fff" />
            <path
                d="M0 64v32h320V64H0zM144 0v160h32V0h-32zM0 160l106.667-53.333h23.85L23.85 160H0zM0 0l106.667 53.333h-23.85L0 11.925V0zm189.483 53.333L296.15 0H320L213.333 53.333h-23.85zM320 160l-106.667-53.333h23.85L320 148.075V160z"
                fill="#cf142b"
            />
            <path
                d="M553.83 148.26v135.513c0 36.197-72.36 47.957-72.36 47.957s-72.358-11.76-72.358-47.957V148.26h144.72z"
                fill="#fff"
            />
            <path
                d="M553.83 283.773c0 36.197-72.36 47.957-72.36 47.957s-72.358-11.76-72.358-47.957c0 0 0-2.915 1.472-4.573 0 0-.797 6.02 3.828 10.574 0 0-3.628-6.423-.08-12.736 0 0-1.316 8.122 3.748 12.786 0 0-2.79-6.635.36-14.033 0 0-1.556 12.104 3.947 14.517 0 0 1.514-6.956-.678-11.42 0 0 3.787 1.528 3.587 11.62 0 0 1.196-1.487 1.515-8.765 0 0 .16 8.323 3.03 10.253 0 0 .878-.844-.318-4.624s.518-5.105.797-5.025c0 0-.628 4.18 2.877 7.318 0 0-1.52-6.554.594-7.44 0 0-.438 5.55 3.948 6.797 0 0 .32-1.61-.638-3.418 0 0-.837-2.146-.2-3.787 0 0 1.396 5.033 3.31 5.878 0 0-1.157-2.95-.08-5.878 0 0 .24 4.19 3.987 5.918 0 0-2.47-3.243-1.494-6.81l24.102 1.18 12.48.596 37.442-2.647 6.46-5.55s2.55 3.54-1.476 9.13c0 0 3.99-.725 5.265-6.958 0 0 1.634 3.458-.6 7.28 0 0 4.428-4.424 5.065-9.45 0 0 1.715 4.864-2.472 10.092 0 0 3.748-1.247 5.343-6.796 0 0 1.277 3.343-2.352 8.066 0 0 6.78-3.6 6.58-11.04 0 0 2.83 4.1-.4 9.73 0 0 3.47-3.096 3.79-7.72 0 0 1.913 2.09-.16 7.84 0 0 4.226-3.98 4.864-8.283 0 0 .917 3.98-2.71 9.007 0 0 2.47-.603 4.824-5.51 0 0 .638 1.932-1.515 5.47 0 0 2.314-.402 3.868-4.825 0 0 .28 2.654-.398 5.027 0 0 1.794-1.166 2.193-6.193 0 0 1.002 1.648 1.02 3.698.015 2.052-.002.705-.002.705z"
                fill="#2f8f22"
            />
            <path
                d="M516.57 205.436s-2.516.427-5.745-.557c-3.23-.985-4.535-.585-5.537 0 0 0 1.31-2.596-1.88-4.645 0 0 1.037 2.62-.398 3.843 0 0-.638.6-1.396-.304 0 0-1.116-1.146-2.292-2.03 0 0 2.71-.945 2.213-3.7-.5-2.754-1.974-3.116-2.77-3.457 0 0 .278 1.246 0 2.09 0 0-2.952-1.648 1.055-3.98 4.007-2.333 3.27-3.7 2.552-4.886-.718-1.185-2.253-2.492-3.01-2.955 0 0 .797 1.247.657 2.313-.14 1.065-1.955 1.75-1.596-.12.36-1.87-.02-1.55-.06-3.54 0 0 3.57 1.207 4.965-2.27 0 0 1.374-3.6-3.132-5.39 0 0 1.097 1.468.558 2.574 0 0-.956 1.81-2.093.342s-1.854-1.75-1.734-3.48c0 0 4.086.565 2.97-3.88 0 0-.658 2.957-5.96-1.024 0 0 3.447-3.54 2.112-6.394 0 0-.42-1.307-4.167-.543 0 0 3.25-2.05 1.874-3.8 0 0-.7-1.165-3.73.362 0 0 1.177-2.03-1.794-4.222 0 0-1.993 1.046-3.05 2.01 0 0-2.033-2.573-3.33-3.598 0 0-2.352.905-2.95 3.6 0 0-1.096-1.308-3.588-1.91 0 0-1.196 2.21.36 4.14 0 0-1.158-.04-3.27-.965 0 0-2.413-1.146-2.055.925.36 2.07.538 2.533 1.017 3.498 0 0-5.413-1.257-5.183 1.67.16 2.03.917 3.778 2.592 5.246 0 0-3.032 3.96-5.624.984 0 0-.897.965 1.037 3.498 0 0 1.934 2.13.34 3.48 0 0-2.134 1.707-3.17-1.61 0 0-3.45 3.438.618 6.072 0 0 2.613 1.488 5.284-.805 0 0-.817 6.594-3.37 5.327 0 0-1.535-1.125 1.216-2.472 0 0-3.967-.503-4.605 3.337 0 0-.49 3.055 2.97 4.162 0 0 2.672.965-.1 3.036 0 0-1.954 1.488-.677 3.7 0 0 1.535 2.432-2.353 2.673 0 0-2.113-.02-2.87-.3 0 0-.854 1.584-.258 3.395 0 0-1.936-1.442-6.342.154-4.406 1.597-4.067.47-4.426.954-.36.482-1.217 2.11-1.217 2.11s2.313 2.815 2.352 2.755c.04-.06-.438 3.217-.438 3.217l1.137.543 9.07-4.04 9.212-4.8 7.405.453 4.698 1.118 6.168.45 4.418-2.356h6.4l7.038 3.507 8.034 4.794 4.187.734 3.225-.172v-6.506l-1.57-2.354z"
                fill="#d40000"
                stroke="#000"
                strokeWidth={0.532}
                strokeLinejoin="round"
            />
            <path
                d="M443.503 213.043s3.51 1.79 4.974-.382c0 0 1.915-3.648-2.288-4.914 0 0 2.287-2.745-.165-5.278 0 0-1.286-1.357-3.53-.36 0 0-.926-1.932-3.11-1.872 0 0-1.913-.03-2.57 2.08 0 0-2.633-1.084-4.098.484 0 0-2.423 2.714.957 4.855l2.432.222 2.392-1.106 2.67.765c.003 0-.685 2.704 2.335 5.508z"
                fill="#d40000"
                stroke="#000"
                strokeWidth={0.532}
                strokeLinejoin="round"
            />
            <path
                d="M521.83 206.626c4.227-.398 5.72 3.17 5.72 3.17 2.215 5.198-2.49 7.973-2.49 7.973.36 1.165.4 2.692.4 2.692 6.617.805 5.46 8.244 5.46 8.244l-2.192-1.81c-3.828-1.488-7.775 1.77-10.606 7.238-2.83 5.47-1.475 8.042-.997 14.516.48 6.473 11.005 10.334 11.005 10.334s-4.984 12.827-8.214 21.07c-3.23 8.243-9.968 4.825-11.922 3.09-1.954-1.738-2.442-.773-3.43 0-.986.77 4.427 4.992-5.422 8.973-9.85 3.98-11.563 7.037-13.198 8.042-1.634 1.004-8.453.32-9.13-.524-.678-.844-.28-.844-2.83-2.413-2.553-1.568-6.86-2.935-11.565-5.227-4.706-2.292-4.586-5.228-4.546-5.83.04-.603 1.634-5.51-3.876-1.61-5.51 3.9-10.2-1.856-10.2-1.856-1.076-1.415-5.662-13.704-5.662-13.704-1.236-4.584-3.668-9.932-3.668-9.932.12-.04-.24.563 3.828-1.77 4.067-2.33 5.888-6.21 7.296-10.05 1.408-3.84.04-10.416-.478-11.743-.52-1.326-3.55-7.41-7.302-8.684-3.752-1.275-6.268 1.89-6.268 1.89s-1.158-7.44 5.46-8.244c0 0 .04-1.527.4-2.693 0 0-4.705-2.776-2.49-7.975 0 0 1.493-3.567 5.72-3.17l-1.022 1.935s-1.065 10.616 14.474 3.5c15.538-7.12 15.072-8.446 23.924-3.982l6.46-.12s9.33-4.317 12.32-2.46c2.99 1.857 13.756 7.888 13.756 7.888s10.407 3.903 12.44-3.296l-1.156-3.464z"
                fill="#64b4d1"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                strokeMiterlimit={10}
                d="M475.078 252.65s-.54-3.258-1.107-5.368c0 0-1.153-3.31.815-5.636l2.44-2.807s1.515-2.04 3.393-2.318c0 0 1.877-.056 2.056-.438.18-.382 2.233-3.76 7.117 0 0 0 1.557-2.493 3.95-2.915 0 0 2.583-.785 3.833 1.145 0 0 2.904-2.202 5.397 1.342 0 0 3.45-1.94 5.96 1.918 0 0 3.41-1.663 5.503 1.88 2.094 3.546 1.675 4.993 1.675 4.993l1.554 5.63 5.504 6.795-12.8 4.825h-5.74l-11.484 3.076-20.395 1.568-5.682-6.695 8.013-6.996z"
                fill="#fff"
                stroke="#00247d"
                strokeWidth={0.532}
            />
            <path
                d="M457.84 286.547s-3.05.182-4.606.966c-1.555.784-2.75 1.628-4.545 2.774 0 0-.838 1.116-4.367.437 0 0-6.1-1.462-6.1 3.303 0 0-7.298.602-4.307 6.996 0 0 2.033 5.006 6.22 1.448 0 0-2.692 3.86 2.512 5.37 0 0 3.708.904 4.784-2.896 0 0 .6-1.508-.837-3.378 0 0 1.795-.362 3.05-2.292 0 0-3.827 4.838.36 6.58 0 0 5.26 1.32 5.56-4.168 0 0-.428-2.533 1.61-3.438 0 0 4.193-.965 6.107-5.64 0 0-6.028-3.21-5.443-6.06zm-12.32-48.107s-4.704-2.167-6.937 0c0 0-3.11-1.926-6.38 0 0 0-3.11 2.033-5.263 4.27 0 0-1.515 1.3-.957 5.388 0 0 .798 2.883.32 4.33 0 0-1.038-.204-3.11 2.253 0 0-2.633 3.048-4.945.358 0 0 .717 3.744 5.063 3.14 0 0-2.112 1.65-.278 5.912 0 0 1.356 3.016-.797 6.795 0 0 3.788-1.527 3.628-5.99 0 0-.32-3.016.797-5.148 0 0-1.116 1.938 1.476 6.072 0 0 1.993 2.975.36 6.07 0 0 3.747-1.366 3.388-5.91-.358-4.544-2.632-2.654-1.156-6.836 0 0 .36 2.142 1.475 3.222 1.116 1.08 2.552 2.89 1.954 5.906 0 0 2.233-2.775 1.714-5.63-.517-2.855-1.075-3.718-1.075-3.718l7.057-4.002 3.51-6.353.16-10.13z"
                fill="#d40000"
                stroke="#000"
                strokeWidth={0.532}
                strokeLinejoin="round"
            />
            <path
                strokeMiterlimit={10}
                d="M434.796 256.37s-2.91-.2-3.39-2.454m-5.104-1.486s1.014-.04 1.932.884c0 0 .7 1.045 1.697.924"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path d="M439.1 247.805s-1.513 0-2.35-.724c0 0-.88-.602-1.397.363 0 0-.797 1.367.678 1.97 0 0 1.835.925-1.076 2.775 0 0 3.47-1.247 2.074-2.935 0 0-1.515-1.086-.957-1.488 0 0 .16-.322.76.08.597.402 1.793.242 2.27-.04z" />
            <path
                fill="#784421"
                stroke="#000"
                strokeWidth={0.399}
                d="M484.877 256.09l1.784-.603-11.658-40.264-.427.114z"
            />
            <path d="M446.057 300.66s-2.75-1.547-5.024.263c0 0 .232-1.006 1.97-1.448 0 0 .94-2.654 3.572-2.413 0 0-1.076 1.286-2.512 2.373 0 0 1.516.156 1.994 1.224z" />
            <path
                strokeMiterlimit={2.613}
                d="M436.368 307.054s-4.366-2.744-2.004-7.358c0 0 .688-1.327 2.004-1.056 0 0 2.72.844.598 4.615 0 0-1.077 2.443-.598 3.8zm8.852 4.343s-6.22-2.834-4.307-7.66c0 0 .592-1.63 1.97-1.508 0 0 2.4.12 1.92 3.317 0 0-.72 3.136.417 5.85z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path d="M443.904 293.39s-1.87 1.38-2.63 2.305c0 0-.76-.945-1.756-1.518 0 0 1.148-.15 1.757.365 0 0 .954-.924 2.63-1.152z" />
            <path
                strokeMiterlimit={2.613}
                d="M449.436 310.19s4.874-1.235 3.978-6.272c0 0-.48-2.2-2.542-1.9 0 0-2.487.635-.868 3.836 0 0 .957 2.286-.568 4.337z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                strokeMiterlimit={2.613}
                d="M471.46 203.645s3.14.963 4.845 1.658c0 0 4.545 2.05 10.317 0 0 0 3.903-1.546 4.424-1.658l-2.99 4.553-.15 2.352 1.87 2.744s-1.12.453-4.47-1.598c0 0-3.71-2.865-8.135 0 0 0-2.42 1.64-4.454 1.598l2.87-3.205-1.106-2.888-3.02-3.557z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                d="M451.32 304.174s.18-.24-.03-.347c0 0-.21-.09-.36.204 0 0-.507.807-.077 1.912 0 0 .407.765.21 1.565 0 0-.028.226.152.256 0 0 .172-.06.206-.225 0 0 .244-.78-.175-1.544 0 0-.508-1.186.075-1.82z"
                fill="#fff"
            />
            <path
                d="M518.84 213.043s-3.51 1.79-4.974-.382c0 0-1.914-3.648 2.288-4.914 0 0-2.288-2.745.164-5.278 0 0 1.286-1.357 3.53-.36 0 0 .926-1.932 3.11-1.872 0 0 1.913-.03 2.57 2.08 0 0 2.633-1.084 4.098.484 0 0 2.422 2.714-.957 4.855l-2.433.222-2.393-1.106-2.67.765c-.002 0 .686 2.704-2.334 5.508z"
                fill="#d40000"
                stroke="#000"
                strokeWidth={0.532}
                strokeLinejoin="round"
            />
            <path
                strokeMiterlimit={2.613}
                d="M491.048 210.21s-.09.723-.807.803c0 0-.748.242-1.184-.69 0 0-.05-.212-.062-.315-.05-.436-.2-1.69 1.156-2.714 0 0 2.214-1.81 6.44.382 0 0 3.35 1.608 5.662 2.975 0 0 5.98 3.218 6.7 3.46 0 0 2.63 1.326 6.658 1.487 0 0 5.502.402 7.834-3.458 0 0 1.775-2.936 0-4.806 0 0-.717-.844-1.897-.69-.495.067-1.043.295-1.57.91 0 0-.858 1.248.138 2.173 0 0 1.296.794 1.754-.884 0 0 .02-.12.06.03.025.097.318 1.377-.37 2.462 0 0-3.32 5.024-12.45-.182l-12.042-6.754s-6.04-3.097-9.65 1.748c0 0-2.91 4.02.838 6.655 0 0 2.79 1.668 4.545-.985 0 0 1.457-2.614-.836-3.76 0 0-2.013-.944-2.81 1.066-.798 2.01 1.554 2.533 1.773 1.106 0 0 .06-.343.12-.02z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M443.315 230.937v-7.54c0-.592.004-1.085.9-1.81.898-.723 1.855-1.87 3.23 1.39 0 0 2.692-2.836 3.59-3.258 0 0 1.554-1.328 2.63.602 0 0 1.436-2.172 2.572-2.715 0 0 2.692-1.75 2.81 3.5l2.095-1.932s1.614-1.326 3.41.483c0 0 3.05 2.955 3.468 3.8 0 0 .673.914.725 2.357 0 0-.008 1.623.83 2.528 0 0 .956.844 1.883 1.025 0 0 2.183.06 2.96 2.11 0 0 .36-.355 1.436 9.473v17.912l-12.082 14.415-19.378-5.55-7.716-3.196-1.734-5.668 7.476-4.825 4.068-10.978-1.316-7.72-1.857-4.403z"
                fill="#e4cb5e"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                d="M496.71 240.446l.917-1.367 2.193-1.69s3.35 8.79 3.51 10.708v2.728s5.023 1.282 5.9 9.002l-4.146 7.64-6.5-3.62-1.873-1.366v-22.036z"
                fill="#784421"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                d="M435.156 300.797s.24-.317.075-.452c0 0-.104-.15-.387.21 0 0-1.32 1.477-.27 3.748 0 0 .12.324.33.218 0 0 .18-.09.014-.36 0 0-.94-1.87.24-3.363z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={10}
                d="M454.75 299.314s.198-.683-.28-1.407c0 0-.318-.523-.2-1.207"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={10}
                d="M459.05 221.106s.017 1.885.556 3.273c.538 1.386 2.356 3.785 2.475 5.082"
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                d="M504.625 286.547s3.05.182 4.605.966c1.555.784 2.75 1.628 4.545 2.774 0 0 .837 1.116 4.366.437 0 0 6.102-1.462 6.102 3.303 0 0 7.297.602 4.306 6.996 0 0-2.033 5.006-6.22 1.448 0 0 2.692 3.86-2.512 5.37 0 0-3.708.904-4.784-2.896 0 0-.6-1.508.837-3.378 0 0-1.796-.362-3.05-2.292 0 0 3.826 4.838-.36 6.58 0 0-5.262 1.32-5.562-4.168 0 0 .43-2.533-1.61-3.438 0 0-4.192-.965-6.106-5.64 0 0 6.028-3.21 5.443-6.06z"
                fill="#d40000"
                stroke="#000"
                strokeWidth={0.532}
                strokeLinejoin="round"
            />
            <path
                strokeMiterlimit={10}
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
                d="M456.643 229.46l4.978 40.18m-3.828-40.268l5.583 37.453m-4.536-37.627l6.43 37.144"
            />
            <path
                fill="#784421"
                stroke="#000"
                strokeWidth={0.399}
                d="M469.01 263.145l1.782-.603-11.66-40.265-.427.115z"
            />
            <path
                strokeMiterlimit={10}
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
                d="M462.407 227.723l11.775 29.752m-12.562-29.271l11.365 31.08"
            />
            <path
                d="M442.967 308.542s-1.366-1.31-1.176-3.66c0 0 .08-.5-.17-.57 0 0-.268-.112-.307.47 0 0-.38 2.454 1.276 3.86 0 0 .11.142.294.1 0 0 .196-.042.083-.2z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={10}
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
                d="M462.938 227.32l12.14 27.14m-15.46-25.454l7.446 36.55"
            />
            <path
                strokeMiterlimit={2.613}
                d="M520.53 256.09c-5.32-3.018-6.485-9.713-6.485-9.713-1.286-6.665 1.316-11.942 1.316-11.942 3.44-7.268 9.333-8.62 9.333-8.62s-5.773 4.005-7.388 9.404c0 0-1.256 4.552-.538 9.046.717 4.493.448 3.347 1.555 6.815l2.207 5.01z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                d="M497.627 239.08l-22.347 7.055-1.22 9.955c-5.302 7.682-16.078 9.045-16.078 9.045l8.384 8.927 16.11 3.378 8.452-6.514 7.656-7.077c-.798-3.78-.36-9.39-.36-9.39 0-.945.36-3.157.36-3.157s-1.316-9.087-.957-12.224z"
                fill="#784421"
                stroke="#000"
                strokeWidth={0.243}
            />
            <path
                strokeMiterlimit={10}
                d="M474.368 253.59s14.718-4.597 23.494-8.287m-30.559 16.677s18.362-3.32 31.28-10.677l4.746-3.205"
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                strokeMiterlimit={10}
                d="M503.33 250.826l-5.105 3.634s-20.535 9.47-36.17 9.722m36.165-2.992s-15.785 8.127-24.836 8.248"
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                d="M517.045 238.44s4.705-2.167 6.938 0c0 0 3.11-1.926 6.38 0 0 0 3.11 2.033 5.263 4.27 0 0 1.515 1.3.957 5.388 0 0-.797 2.883-.32 4.33 0 0 1.038-.204 3.112 2.253 0 0 2.63 3.048 4.944.358 0 0-.72 3.744-5.065 3.14 0 0 2.113 1.65.28 5.912 0 0-1.356 3.016.797 6.795 0 0-3.79-1.527-3.63-5.99 0 0 .32-3.016-.796-5.148 0 0 1.116 1.938-1.475 6.072 0 0-1.993 2.975-.358 6.07 0 0-3.748-1.366-3.39-5.91.36-4.544 2.632-2.654 1.157-6.836 0 0-.36 2.14-1.476 3.222-1.117 1.08-2.552 2.89-1.954 5.906 0 0-2.233-2.775-1.715-5.63s1.077-3.718 1.077-3.718l-7.058-4.002-3.51-6.353-.16-10.13z"
                fill="#d40000"
                stroke="#000"
                strokeWidth={0.532}
                strokeLinejoin="round"
            />
            <path
                strokeMiterlimit={10}
                d="M437.1 263.87s.657-3.118 3.648-1.89c0 0 1.017-5.108 6.46-5.29 5.442-.18 5.74 5.31 5.74 5.67 0 0 1.6-2.355 4.27-2.082 0 0 4.602-.27 2.888 7.118l.87.927s3.516-8.254 10.753-6.083c0 0 7.057 2.15 2.452 8.987 0 0 3.483 4.524 6.436 4.1 2.954-.42 5.586-1.325 8.516-6.513 2.93-5.187 9.75-5.97 11.484-5.67 1.734.302 3.104 1.428 3.387 2.655 0 0 3.61-12.05 16.59-10.157l5.202 2.616 1.974.904-2.94 8.304-7.17 16.2-5.44 1.674-5.682-3.257-1.974 1.058-.16 4.852-7.495 5.395-5.204 2.144-5.742 3.92-1.336 3.506s-3.17-1.336-6.75 0l-1.184-2.9-3.35-3.198-13.01-6.138-2.35-7.58-2.376-1.06-2.66 3.046-3.886.453-5.802-3.92-6.16-17.794z"
                fill="#fff"
                stroke="#00247d"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M493.76 204.88s-4.966-.22-4.787 4.927"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M526.426 259.556c-8.643-2.654-11.005-11.942-11.005-11.942-1.764-6.967 1.077-13.058 1.077-13.058 3.948-9.27 10.627-9.27 10.627-9.27 3.35-.09 3.75 2.776 3.75 2.776.317 2.03-1.108 2.764-1.108 2.764-2.293 1.247-3.738-.442-3.738-.442-.957-1.247-.22-2.352-.22-2.352.588-.825 1.715-.463 1.715-.463.892.275.797 1.39.797 1.39.005.03.025.03.025.03.04-.01.025-.024.025-.024s.2-1.367-1.137-1.508c0 0-2.6-.563-5.65 3.237 0 0-4.018 5.127-4.01 11.762 0 0-.507 12.455 12.472 15.682 0 0-1.406 2.02-3.887 9.317 0 0-2.81 9.38-5.495 14.45 0 0-3.567 7.233-11.522 4.278 0 0-4.735-2.08-4.724-5.52 0 0-.33-3.136 2.512-3.377 0 0 2.782-.21 2.75 2.17 0 0 .076 2.58-2.96 1.992 0 0-1.06-.226-.866-1.267 0 0 .17-.935 1.45-.528 0 0 .04.005.045-.015 0 0 .014-.022-.03-.035 0 0-.496-.222-1.02-.04 0 0-.468.157-.506.89 0 0-.03.587.6.92 0 0 .763.27 1.36.21 0 0 .805 1.624 2.625 2.174 2.534.765 4.62.027 5.898-.992 1.39-1.108 2.288-3.046 2.557-3.52.27-.475 2.602-5.7 4.356-11.32 0 0 1.535-4.845 2.76-7.378l.48-.994z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M502.038 283.17s1.614-.22 1.614 1.22c0 0-.098 2.104-2.66 1.644 0 0-2.528-.553-1.63-3.378 0 0 .597-1.99 2.99-1.703 0 0 2.317.105 3.334 3.272 0 0 .777 2.67-.553 4.96-1.486 2.558-5.244 4.238-7.057 4.982 0 0-7.268 2.855-9.435 4.488 0 0-3.324 2.468-1.853 4.765 0 0 .568.875 1.42.875 0 0 .973.045 1.137-.95 0 0 .005-.02-.01-.045 0 0-.015 0-.02.025 0 0-.07.608-.598.834 0 0-.708.356-1.45-.272 0 0-.788-.754-.13-1.925 0 0 .862-1.443 2.87-.59 0 0 1.77.876 1.043 2.756 0 0-.65 1.73-2.782 1.724 0 0-1.607-.053-2.634-1.13-1.603-1.68-1.69-4.954-.277-6.647 0 0 1.336-1.8 4.017-2.895 1.553-.635 4.486-1.91 7.536-3.106 2.144-.84 4.108-1.848 5.383-3.358 0 0 1.137-1.266 1.466-3.438 0 0 .313-1.628-.68-1.985 0 0-.503-.226-1.056-.15 0 0-.014 0-.018.01 0 0-.024.024.032.015z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M502.173 283.16s1.784-.323 2.9 1.8c0 0 .658 1.366.764 2.157m.583-7.584s-1.788.31-.868 2.838c.867 2.384 2.478 3.165 2.956 3.497"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M471.458 210.208s.088.724.806.805c0 0 .75.24 1.186-.69 0 0 .05-.213.062-.316.05-.436.2-1.69-1.157-2.714 0 0-2.213-1.81-6.44.382 0 0-3.35 1.608-5.662 2.976 0 0-5.98 3.217-6.698 3.458 0 0-2.632 1.327-6.66 1.488 0 0-5.502.402-7.834-3.457 0 0-1.773-2.937 0-4.807 0 0 .72-.844 1.9-.688.494.065 1.04.293 1.57.91 0 0 .857 1.247-.14 2.17 0 0-1.296.796-1.754-.883 0 0-.02-.12-.06.03-.026.097-.32 1.377.37 2.463 0 0 3.318 5.023 12.45-.183l12.04-6.754s6.042-3.096 9.65 1.75c0 0 2.91 4.02-.837 6.654 0 0-2.792 1.67-4.546-.985 0 0-1.456-2.614.837-3.76 0 0 2.014-.944 2.812 1.067.797 2.01-1.556 2.533-1.774 1.105 0 0-.06-.343-.12-.022zm-29.482 45.882c5.32-3.018 6.485-9.713 6.485-9.713 1.287-6.665-1.315-11.942-1.315-11.942-3.44-7.268-9.333-8.62-9.333-8.62s5.774 4.005 7.39 9.404c0 0 1.255 4.552.537 9.046-.72 4.493-.45 3.347-1.556 6.815l-2.208 5.01z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M468.746 204.88s4.966-.22 4.786 4.927"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M436.08 259.556c8.643-2.654 11.005-11.942 11.005-11.942 1.764-6.967-1.077-13.058-1.077-13.058-3.947-9.27-10.626-9.27-10.626-9.27-3.35-.09-3.75 2.776-3.75 2.776-.317 2.03 1.108 2.764 1.108 2.764 2.292 1.247 3.738-.442 3.738-.442.957-1.247.22-2.352.22-2.352-.59-.825-1.715-.463-1.715-.463-.892.275-.797 1.39-.797 1.39-.005.03-.025.03-.025.03-.04-.01-.024-.024-.024-.024s-.2-1.367 1.136-1.508c0 0 2.602-.563 5.652 3.237 0 0 4.017 5.127 4.007 11.762 0 0 .51 12.455-12.47 15.682 0 0 1.406 2.02 3.888 9.317 0 0 2.81 9.38 5.494 14.45 0 0 3.568 7.233 11.522 4.278 0 0 4.737-2.08 4.726-5.52 0 0 .328-3.136-2.512-3.377 0 0-2.782-.21-2.752 2.17 0 0-.075 2.58 2.96 1.992 0 0 1.063-.226.868-1.267 0 0-.17-.935-1.45-.528 0 0-.04.005-.045-.015 0 0-.016-.022.03-.035 0 0 .494-.222 1.018-.04 0 0 .47.157.506.89 0 0 .03.587-.598.92 0 0-.763.27-1.36.21 0 0-.805 1.624-2.625 2.174-2.533.765-4.62.027-5.898-.992-1.39-1.108-2.288-3.046-2.557-3.52-.268-.475-2.6-5.7-4.355-11.32 0 0-1.536-4.845-2.76-7.378l-.48-.994z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M460.468 283.17s-1.615-.22-1.615 1.22c0 0 .1 2.104 2.662 1.644 0 0 2.527-.553 1.63-3.378 0 0-.598-1.99-2.99-1.703 0 0-2.318.105-3.335 3.272 0 0-.778 2.67.553 4.96 1.485 2.558 5.243 4.238 7.057 4.982 0 0 7.267 2.855 9.435 4.488 0 0 3.324 2.468 1.854 4.765 0 0-.57.875-1.422.875 0 0-.972.045-1.136-.95 0 0-.005-.02.01-.045 0 0 .015 0 .02.025 0 0 .07.608.598.834 0 0 .708.356 1.45-.272 0 0 .787-.754.13-1.925 0 0-.863-1.443-2.872-.59 0 0-1.77.876-1.04 2.756 0 0 .646 1.73 2.78 1.724 0 0 1.606-.053 2.634-1.13 1.603-1.68 1.69-4.954.277-6.647 0 0-1.337-1.8-4.02-2.895-1.552-.635-4.484-1.91-7.535-3.106-2.144-.84-4.107-1.848-5.383-3.358 0 0-1.136-1.266-1.465-3.438 0 0-.314-1.628.678-1.985 0 0 .503-.226 1.056-.15 0 0 .016 0 .02.01 0 0 .024.024-.032.015z"
                fill="#f5ce00"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M460.333 283.16s-1.785-.323-2.9 1.8c0 0-.66 1.366-.765 2.157m-.581-7.585s1.787.31.867 2.838c-.868 2.383-2.478 3.164-2.957 3.496m22.935-76.35s4.32-2.705 8.733.29"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M452.35 235.943s.6-2.412-2.152-6.635c0 0-1.795-3.86-2.752-6.332m6.221-2.654s1.557 3.794 2.093 5.493c0 0 1.932 4.76 2.342 5.725"
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                strokeMiterlimit={10}
                d="M454.444 238.597s1.624 1.75 1.44 4.704m-6.824-6.574s1.796.865 1.677 5.63c0 0-.18 3.478 2.51 5.227m-4.429 1.226s5.616-.613 5.925 2.845c0 0 .12 3.317 2.033 3.68 0 0 2.867.27 3.435 2.925m-9.625-5.61s.987 1.478 1.944 2.11m5.263-5.76s1.427 2.163 1.696 3.43m4.485-29.455s1.316 1.79 2.592 2.634m2.671 7.961s2.79 1.368 2.313 8.405c0 0-.36 4.126.798 6.38"
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                d="M456.09 228.796l.178.663s5.004.21 7.706-3.197l-.29-.654s-4.366-.222-7.595 3.186z"
                fill="#784421"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path
                strokeMiterlimit={10}
                d="M474.116 255.643s17.307-5.16 23.977-8.168"
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
            />
            <path fill="#784421" stroke="#000" strokeWidth={0.243} d="M472.26 223.724l-.202-.568 8.56-3.257.202.572z" />
            <path
                strokeMiterlimit={10}
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
                d="M472.985 223.448l5.682 27.855m-4.697-28.229l6.51 27.727m-5.402-28.148l7.118 27.525m-4.326-28.585l9.702 20.66m-8.419-21.147l10.347 20.54m-9.397-20.901l11.192 20.334m-13.012 10.445l4.392-1.447m-7.717-1.309s12.873-3.76 22.616-7.69m-22.789 9.1s16.315-4.317 22.788-7.467m-17.809 20.736l.854 2.613 2.336-.747-.798-2.59m4.197-1.153l.855 2.612 2.336-.747-.798-2.59m-13.466-14.71l-.202-3.536 21.392-6.496 1.157 2.975m-13.477.767l1.166 3.122m6.314-5.393l1.36 2.97m.412-3.508l1.274 2.81m.42-3.326l1.34 2.936"
            />
            <path
                strokeMiterlimit={10}
                fill="none"
                stroke="#000"
                strokeWidth={0.399}
                d="M496.47 236.104l2.353-1.327.997 2.613m-2.193-1.938l1.198 2.705"
            />
            <path
                strokeMiterlimit={10}
                d="M444.575 276.173s-4.187-4.24 0-8.393c0 0-4.545-2.223-3.827-5.8m11.304 17.552s-4.336.59-3.05-7.852c0 0-1.795 3.347-2.413 5.067-.464 1.288-.158 3.367 1.678 4.49.733.45 4.62 1.462 5.877-1.113m-6.937-13.511s-1.764 1.63-.508 4.615m2.331-4.223s.21 2.895 1.646 4.524m-.406-5.669s-.012 3.407 2.44 5.518m-1.22-6.695s.024 3.83 2.865 6.183m11.245-.574s1.434-3.137 4.454-2.985c0 0-1.465.663-1.435 2.13 0 0-.18 2.423 2.42 2.664 0 0 2.095.273 3.14-.873"
                fill="none"
                stroke="#00247d"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={10}
                d="M472.746 284.617s-7.446-3.498-6.67-8.534c0 0 .3-3.076 3.308-4.524m-1.572 3.196s-.658 2.172.808 3.68m.866-5.157s-.897 2.382.598 4.162m1.196-5.32s-1.076 1.972.21 3.75m-6.998 9.26s4.067 3.528 7.237 3.558m-8.523-2.443s3.8 3.076 6.177 3.53m-7.613-2.659s4.7 4.135 7.613 4.437m11.497 3.8s-4.618 2.49-1.038 5.12m-1.892-7.863s5.233-2.745 7.505-3.77m-5.621 5.187s7.566-4.615 9.808-5.61m-5.922 5.911s6.46-4.312 9.93-6.182m-5.653 6.031s4.456-3.498 8.763-6.03m1.525-4.374s-2.183-3.197-9.36 0c0 0 2.63-2.388 7.835-4.24m7.245-13.733s.588 2.592-.04 4.16"
                fill="none"
                stroke="#00247d"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={10}
                d="M492.364 278.375s1.495-2.202 5.293-3.287c0 0 1.024 2.563 3.978 1.99 0 0 4.455-.875 3.11-5.76 0 0-.927-3.65-6.016-4.01m15.137-6.118s5.173.93 5.084 5.152c0 0 .418 6.333-6.25 7.57m5.515-10.122s1.42-3.088 4.59-4.355m-3.851-1.808s1.413 2.265 2.38 2.595m-3.119-.786s1.332 1.627 1.78 1.9m-2.212-.332s.7 1.036 1.323 1.362m-27.939-25.846s1.007-1.633 3.51-.94m10.217 13.188s1.585-6.612 7.118-4.17m-2.244-.541s.57-3.05-.807-4.6M506 243.844s.705 1.26.102 2.29"
                fill="none"
                stroke="#00247d"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M517.245 311.397s6.22-2.835 4.306-7.66c0 0-.59-1.63-1.97-1.508 0 0-2.398.12-1.918 3.316 0 0 .72 3.137-.417 5.85z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M519.498 308.542s1.367-1.31 1.176-3.66c0 0-.08-.5.17-.57 0 0 .268-.113.308.47 0 0 .38 2.453-1.276 3.86 0 0-.113.14-.296.1 0 0-.196-.042-.082-.2z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M526.097 307.054s4.366-2.744 2.003-7.358c0 0-.688-1.327-2.003-1.056 0 0-2.722.844-.6 4.615 0 0 1.078 2.443.6 3.8z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M527.188 300.796s-.24-.316-.075-.452c0 0 .105-.15.388.21 0 0 1.322 1.478.27 3.748 0 0-.12.324-.328.22 0 0-.18-.092-.015-.363 0 0 .942-1.87-.24-3.364z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M513.028 310.19s-4.874-1.235-3.978-6.272c0 0 .48-2.2 2.542-1.9 0 0 2.487.635.868 3.836 0 0-.957 2.286.568 4.337z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M511.144 304.174s-.18-.24.03-.347c0 0 .21-.09.36.204 0 0 .507.807.077 1.912 0 0-.406.765-.208 1.565 0 0 .027.226-.153.256 0 0-.173-.06-.207-.225 0 0-.243-.78.176-1.544 0 0 .507-1.186-.076-1.82z"
                fill="#fff"
            />
            <path d="M516.527 300.66s2.75-1.547 5.024.263c0 0-.232-1.006-1.97-1.448 0 0-.94-2.654-3.572-2.413 0 0 1.077 1.286 2.512 2.373 0 0-1.515.156-1.993 1.224zm2.033-7.27s1.87 1.38 2.63 2.305c0 0 .76-.945 1.757-1.518 0 0-1.148-.15-1.757.365 0 0-.955-.924-2.63-1.152z" />
            <path
                strokeMiterlimit={10}
                d="M507.715 299.314s-.2-.683.28-1.407c0 0 .318-.523.2-1.207m19.575-40.33s2.912-.2 3.39-2.454m5.104-1.486s-1.014-.04-1.93.884c0 0-.7 1.045-1.698.924"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path d="M523.465 247.805s1.515 0 2.353-.724c0 0 .877-.602 1.395.363 0 0 .798 1.367-.677 1.97 0 0-1.835.925 1.076 2.775 0 0-3.47-1.247-2.073-2.935 0 0 1.513-1.086.955-1.488 0 0-.16-.322-.757.08-.6.402-1.795.242-2.273-.04z" />
            <path
                strokeMiterlimit={2.613}
                d="M525.526 211.188s.684-.93.404-3.725 2.147-3.116 3.08-2.313c0 0 .964.836.077 2.608-.512 1.022-1.33 2.347-3.56 3.43z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M526.438 209.102s.91-.978.475-3.1c0 0-.003-.21.117-.224 0 0 .22-.056.258.153 0 0 .49 2.264-.538 3.494 0 0-.187.18-.313 0 0 0-.137-.13 0-.322z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M524.75 210.172s-.07-1.127-2.018-3.04c-1.947-1.915-.346-3.68.846-3.664 0 0 1.235.02 1.68 1.9.257 1.09.474 2.592-.507 4.804z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M524.448 207.723s.035-1.38-1.728-2.82c0 0-.143-.168-.06-.257 0 0 .13-.187.3-.042 0 0 1.898 1.52 1.944 3.177 0 0-.02.27-.24.204 0 0-.193-.017-.216-.26z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M522.107 209.325s-.51-.918-2.913-1.77c-2.405-.854-1.755-2.954-.743-3.404 0 0 1.05-.46 2.175.947.65.814 1.43 1.99 1.482 4.228z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M521.053 207.638s-.546-1.265-2.748-1.82c0 0-.2-.09-.163-.206 0 0 .04-.226.255-.167 0 0 2.357.567 3.094 2.052 0 0 .094.252-.13.284 0 .002-.183.07-.307-.142z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M523.613 210.244s-1.12.315-3.696-.927c-2.574-1.242-3.702.92-3.25 2.076 0 0 .47 1.197 2.464.987 1.152-.122 2.693-.423 4.483-2.136z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M517.626 211.065s1.168.72 3.286-.1c0 0 .216-.04.25.075 0 0 .097.208-.113.284 0 0-2.254.898-3.702.11 0 0-.22-.153-.055-.31 0 0 .112-.162.333-.06z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M519.846 202.107s1.286.623.987 2.13"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={10}
                d="M525.528 202.318s.503 1.592-.052 2.45"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={2.613}
                d="M436.818 211.188s-.684-.93-.405-3.725c.28-2.795-2.146-3.116-3.08-2.313 0 0-.964.836-.077 2.608.512 1.022 1.33 2.347 3.562 3.43z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M435.905 209.102s-.91-.978-.475-3.1c0 0 .003-.21-.117-.224 0 0-.22-.056-.258.153 0 0-.49 2.264.538 3.494 0 0 .187.18.313 0 0 0 .138-.13 0-.322z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M437.592 210.172s.072-1.127 2.02-3.04c1.946-1.915.345-3.68-.847-3.664 0 0-1.235.02-1.68 1.9-.257 1.09-.474 2.592.507 4.804z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M437.896 207.723s-.035-1.38 1.728-2.82c0 0 .143-.168.06-.257 0 0-.13-.187-.3-.042 0 0-1.898 1.52-1.944 3.177 0 0 .02.27.24.204 0 0 .192-.017.216-.26z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M440.236 209.325s.51-.918 2.913-1.77c2.404-.854 1.754-2.954.742-3.404 0 0-1.05-.46-2.174.947-.65.814-1.43 1.99-1.482 4.228z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M441.29 207.638s.546-1.265 2.748-1.82c0 0 .2-.09.163-.206 0 0-.04-.226-.254-.167 0 0-2.357.567-3.094 2.052 0 0-.093.252.132.284 0 .002.182.07.306-.142z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M438.73 210.244s1.12.315 3.696-.927c2.574-1.242 3.702.92 3.25 2.076 0 0-.47 1.197-2.464.987-1.15-.122-2.692-.423-4.482-2.136z"
                fill="#64b4d1"
                stroke="#00247d"
                strokeWidth={0.399}
            />
            <path
                d="M444.717 211.065s-1.168.72-3.286-.1c0 0-.215-.04-.25.075 0 0-.096.208.114.284 0 0 2.254.898 3.7.11 0 0 .22-.153.056-.31 0 0-.11-.162-.333-.06z"
                fill="#fff"
            />
            <path
                strokeMiterlimit={2.613}
                d="M442.497 202.107s-1.286.623-.987 2.13"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path
                strokeMiterlimit={10}
                d="M436.815 202.318s-.503 1.592.052 2.45"
                fill="none"
                stroke="#000"
                strokeWidth={0.532}
            />
            <path d="M492.633 187.69s.815 2.327.463 4.434c-.314 1.885.115 2.372.796 2.745.59.322 1.955-.243 2.12-1.72 0 0 1.614 3.15-1.526 5.277 0 0-2.258 1.388-4.17-.467-.676-.653-.973-2.458-.644-4.132 0 0 .494-2.27-.33-4.6 0 0 1.286 1.373.958 4.11 0 0-.658 4.908 2.975 4.667 0 0 2.512-.03 2.587-3.076 0 0-.942 1.084-2.108.723-.827-.256-1.586-1.056-1.45-2.316.14-1.32.508-3.625.33-5.646zm-4.117 8.063s-.2 3.88-3.748 4.825c0 0 .5-.703-.3-2.633 0 0-.776-1.126-.716-2.875 0 0-1.13.884.16 3.216.777 1.408.1 3.097-.14 3.157-.24.06 5.86-.805 4.744-5.69zm-4.606-3.86s-.857-.965-.917-3.197c-.06-2.232-.478-2.774-.777-3.036 0 0 .438 1.93.318 3.116-.12 1.186.08 1.87.24 2.433 0 0-1.934.3-3.15-2.515-1.163-2.69-2.333-2.473-2.91-2.453 0 0 .673.075 2.032 2.533 1.358 2.457 1.735 2.957 5.164 3.118zm-9.05-5.831s1.116 2.674 1.156 4.082c0 0-2.592-.865-3.29-3.117 0 0-2.77.945-1.754 4.142 0 0-2.392-.845-3.47-2.796 0 0 1.337 1.005 2.573 1.448 0 0-.14-2.574 3.09-3.54 0 0 .48 2.306 2.093 2.856 0 0-.12-1.447-.398-3.076zm4.266-4.582s.897 1.306 2.73 1.366c.878.03 1.82-.17 2.733-1.367 0 0-.12 2.27-2.733 2.29 0 0-2.73.1-2.73-2.29zm-11.299 15.53s1.36 1.236 1.644 1.643c0 0 .958.935 1.78-.274 0 0 1.048-1.934 2.333-1.883 0 0-.912.634-1.937 2.46 0 0-.276.676-1.04.75-.356.037-.806.152-1.488-.56 0 0-.59-.72-1.29-2.137zm14.03-24.64c-2.73 0-.43 2.112-.43 2.112.06 3.347-2.625 4.377-4.454 3.408-1.83-.97-.4-3.408-.4-3.408s-2.062 1.356-.746 3.317c1.315 1.96 4.764 1.084 6.03-.725 1.266 1.81 4.715 2.684 6.03.724 1.317-1.962-.747-3.318-.747-3.318s1.43 2.437-.398 3.408c-1.83.97-4.516-.06-4.456-3.408 0 0 2.302-2.112-.43-2.11zm1.655-3.618s.956 1.63.747 4.1c0 0 .866-2.472-.748-4.1zm-8.372 3.83s-.21-1.78-1.945-1.93c0 0 1.465 1.056 1.944 1.93zm13.456 0s.21-1.78 1.944-1.93c0 0-1.466 1.056-1.944 1.93zm-16.209 2.714s1.376.423 2.213-.603c0 0-1.585.422-2.213.603zm-4.455-10.916s1.6-.182 3.2 2.2c0 0-1.586.845-1.974 1.358 0 0 0-.784.777-1.478 0 0-.3-1.206-2.003-2.08zm26.794 0s-1.6-.182-3.2 2.2c0 0 1.586.845 1.974 1.358 0 0 0-.784-.777-1.478 0 0 .298-1.206 2.003-2.08zm-12.35 1.777s1.435.394 3.23-.602c0 0 2.212-1.176 3.618 0 0 0-1.227-.545-3.59.602 0 0-2.362 1.295-3.258 0z" />
            <path d="M483.87 167.606s1.227-2.15 4.965-1.723c0 0-1.017 2.99-4.964 1.723z" fill="#fff" />
            <ellipse cx={486.449} cy={166.939} rx={0.739} ry={0.937} fill="#784421" />
            <ellipse cx={486.449} cy={166.939} rx={0.439} ry={0.575} />
            <path d="M475.856 163.022s2.362.15 3.798 1.056c0 0 1.525.905 3.26-.393 0 0 1.885-1.085 3.096-2.593 0 0-2.887 1.99-3.964 2.292 0 0-.987-.754-1.375-1.84 0 0 .15-.813 1.705-2.32 0 0-2.093.632-2.512 2.41 0 0 .39 1.087 1.196 1.932 0 0-.39.18-1.406-.453 0 0-2.213-.754-3.798-.09zm6.001 14.188c-2.043 1.766 0 1.585 0 1.585s2.044.18 0-1.584zm-1.182-11.053s-1.436.394-3.23-.602c0 0-2.214-1.176-3.62 0 0 0 1.227-.545 3.59.602 0 0 2.362 1.295 3.26 0z" />
            <path d="M479.18 167.606s-1.227-2.15-4.965-1.723c0 0 1.017 2.99 4.965 1.723z" fill="#fff" />
            <ellipse cx={476.601} cy={166.939} rx={0.739} ry={0.937} fill="#784421" />
            <ellipse cx={476.601} cy={166.939} rx={0.439} ry={0.575} />
            <path
                d="M554.063 148.26v135.513c0 36.197-72.36 47.957-72.36 47.957s-72.36-11.76-72.36-47.957V148.26h144.72z"
                fill="none"
                stroke="#000"
                strokeWidth={1.28}
            />
        </svg>
    );
}

export default SvgBm;
